export const themes = {
    modern: {
        primary: 'bg-[#09090b]',
        secondary: 'bg-[#18181b]/90',
        text: 'text-zinc-100',
        accent: 'bg-blue-600',
        highlight: 'bg-blue-500/15 text-blue-400 border border-blue-500/30',
        opponent: 'bg-[#27272a]/90 backdrop-blur-xl',
        badge: 'bg-blue-500',
        hover: 'hover:bg-[#27272a]',
        input: 'bg-[#27272a] border border-[#3f3f46]',
        bubbleSelf: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)',
        bubbleOther: 'rgba(39, 39, 42, 0.85)',
        button: 'bg-gradient-to-r from-blue-600 to-violet-600',
        modalHeader: 'bg-[#18181b]',
        sidebar: 'bg-[#18181b]/95 backdrop-blur-3xl',
        header: 'bg-[#09090b]/80 backdrop-blur-3xl',
        chat: '#09090b',
        inputBg: 'rgba(39, 39, 42, 0.6)',
        border: 'border-[#27272a]',
        shadow: 'shadow-2xl shadow-black/50',
        hoverShadow: 'hover:shadow-blue-500/20',
        transition: 'transition-all duration-300 cubic-bezier(0.4, 0, 0.2, 1)',
        cssVars: {
            '--primary-bg': '#09090b',
            '--secondary-bg': '#18181b',
            '--text-primary': '#f4f4f5',
            '--text-secondary': '#a1a1aa',
            '--accent-primary': '#6c5ce7',
            '--accent-secondary': '#a29bfe',
            '--gradient-primary': 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            '--gradient-secondary': 'linear-gradient(135deg, #27272a 0%, #18181b 100%)',
            '--gradient-accent': 'linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%)',
            '--gradient-accent-hover': 'linear-gradient(90deg, #60a5fa 0%, #a78bfa 100%)',
            '--glass-bg': 'rgba(24, 24, 27, 0.75)',
            '--glass-bg-light': 'rgba(255, 255, 255, 0.04)',
            '--glass-bg-hover': 'rgba(255, 255, 255, 0.08)',
            '--glass-border': 'rgba(255, 255, 255, 0.08)',
            '--glass-border-hover': 'rgba(255, 255, 255, 0.15)',
            '--border-color': 'rgba(255, 255, 255, 0.06)',
            '--hover-bg': 'rgba(255, 255, 255, 0.06)',
        }
    },
    cyberpunk: {
        primary: 'bg-[#030712]',
        secondary: 'bg-[#0f172a]/90',
        text: 'text-[#00f0ff]',
        accent: 'bg-[#ff007f]',
        highlight: 'bg-[#00f0ff]/15 text-[#00f0ff] border border-[#00f0ff]/30',
        opponent: 'bg-[#1e1b4b]/90 backdrop-blur-xl',
        badge: 'bg-[#ff007f]',
        hover: 'hover:bg-[#1e293b]',
        input: 'bg-[#0f172a] border border-[#00f0ff]/30',
        bubbleSelf: 'linear-gradient(135deg, #ff007f 0%, #7e22ce 100%)',
        bubbleOther: 'rgba(30, 27, 75, 0.85)',
        button: 'bg-gradient-to-r from-[#ff007f] to-[#7e22ce]',
        modalHeader: 'bg-[#0f172a]',
        sidebar: 'bg-[#0f172a]/95 backdrop-blur-3xl',
        header: 'bg-[#030712]/80 backdrop-blur-3xl',
        chat: '#030712',
        inputBg: 'rgba(15, 23, 42, 0.6)',
        border: 'border-[#1e293b]',
        shadow: 'shadow-2xl shadow-[#ff007f]/20',
        hoverShadow: 'hover:shadow-[#00f0ff]/30',
        transition: 'transition-all duration-300 cubic-bezier(0.4, 0, 0.2, 1)',
        cssVars: {
            '--primary-bg': '#030712',
            '--secondary-bg': '#0f172a',
            '--text-primary': '#e2e8f0',
            '--text-secondary': '#64748b',
            '--accent-primary': '#ff007f',
            '--accent-secondary': '#00f0ff',
            '--gradient-primary': 'linear-gradient(135deg, #ff007f 0%, #7e22ce 100%)',
            '--gradient-secondary': 'linear-gradient(135deg, #1e1b4b 0%, #0f172a 100%)',
            '--gradient-accent': 'linear-gradient(90deg, #ff007f 0%, #7e22ce 100%)',
            '--gradient-accent-hover': 'linear-gradient(90deg, #ff4fa1 0%, #9333ea 100%)',
            '--glass-bg': 'rgba(15, 23, 42, 0.75)',
            '--glass-bg-light': 'rgba(0, 240, 255, 0.04)',
            '--glass-bg-hover': 'rgba(0, 240, 255, 0.08)',
            '--glass-border': 'rgba(0, 240, 255, 0.15)',
            '--glass-border-hover': 'rgba(0, 240, 255, 0.25)',
            '--border-color': 'rgba(0, 240, 255, 0.1)',
            '--hover-bg': 'rgba(0, 240, 255, 0.06)',
        }
    },
    sunset: {
        primary: 'bg-[#12071f]',
        secondary: 'bg-[#1f0e30]/90',
        text: 'text-amber-100',
        accent: 'bg-orange-500',
        highlight: 'bg-orange-500/15 text-orange-400 border border-orange-500/30',
        opponent: 'bg-[#2d0f3d]/90 backdrop-blur-xl',
        badge: 'bg-orange-500',
        hover: 'hover:bg-[#2d0f3d]',
        input: 'bg-[#2d0f3d] border border-[#f97316]/30',
        bubbleSelf: 'linear-gradient(135deg, #f97316 0%, #db2777 100%)',
        bubbleOther: 'rgba(45, 15, 61, 0.85)',
        button: 'bg-gradient-to-r from-orange-500 to-rose-600',
        modalHeader: 'bg-[#1f0e30]',
        sidebar: 'bg-[#1f0e30]/95 backdrop-blur-3xl',
        header: 'bg-[#12071f]/80 backdrop-blur-3xl',
        chat: '#12071f',
        inputBg: 'rgba(45, 15, 61, 0.6)',
        border: 'border-[#2d0f3d]',
        shadow: 'shadow-2xl shadow-orange-500/20',
        hoverShadow: 'hover:shadow-rose-500/30',
        transition: 'transition-all duration-300 cubic-bezier(0.4, 0, 0.2, 1)',
        cssVars: {
            '--primary-bg': '#12071f',
            '--secondary-bg': '#1f0e30',
            '--text-primary': '#fdf2f8',
            '--text-secondary': '#fda4af',
            '--accent-primary': '#f97316',
            '--accent-secondary': '#db2777',
            '--gradient-primary': 'linear-gradient(135deg, #f97316 0%, #db2777 100%)',
            '--gradient-secondary': 'linear-gradient(135deg, #2d0f3d 0%, #1f0e30 100%)',
            '--gradient-accent': 'linear-gradient(90deg, #f97316 0%, #db2777 100%)',
            '--gradient-accent-hover': 'linear-gradient(90deg, #fb923c 0%, #ec4899 100%)',
            '--glass-bg': 'rgba(31, 14, 48, 0.75)',
            '--glass-bg-light': 'rgba(249, 115, 22, 0.04)',
            '--glass-bg-hover': 'rgba(249, 115, 22, 0.08)',
            '--glass-border': 'rgba(249, 115, 22, 0.15)',
            '--glass-border-hover': 'rgba(249, 115, 22, 0.25)',
            '--border-color': 'rgba(249, 115, 22, 0.1)',
            '--hover-bg': 'rgba(249, 115, 22, 0.06)',
        }
    },
    nordic: {
        primary: 'bg-[#0f1716]',
        secondary: 'bg-[#1b2b28]/90',
        text: 'text-emerald-100',
        accent: 'bg-emerald-600',
        highlight: 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/30',
        opponent: 'bg-[#243a36]/90 backdrop-blur-xl',
        badge: 'bg-emerald-500',
        hover: 'hover:bg-[#243a36]',
        input: 'bg-[#243a36] border border-[#10b981]/30',
        bubbleSelf: 'linear-gradient(135deg, #10b981 0%, #0f766e 100%)',
        bubbleOther: 'rgba(36, 58, 54, 0.85)',
        button: 'bg-gradient-to-r from-emerald-500 to-teal-600',
        modalHeader: 'bg-[#1b2b28]',
        sidebar: 'bg-[#1b2b28]/95 backdrop-blur-3xl',
        header: 'bg-[#0f1716]/80 backdrop-blur-3xl',
        chat: '#0f1716',
        inputBg: 'rgba(36, 58, 54, 0.6)',
        border: 'border-[#243a36]',
        shadow: 'shadow-2xl shadow-emerald-500/10',
        hoverShadow: 'hover:shadow-teal-500/20',
        transition: 'transition-all duration-300 cubic-bezier(0.4, 0, 0.2, 1)',
        cssVars: {
            '--primary-bg': '#0f1716',
            '--secondary-bg': '#1b2b28',
            '--text-primary': '#f0fdf4',
            '--text-secondary': '#a7f3d0',
            '--accent-primary': '#10b981',
            '--accent-secondary': '#0f766e',
            '--gradient-primary': 'linear-gradient(135deg, #10b981 0%, #0f766e 100%)',
            '--gradient-secondary': 'linear-gradient(135deg, #243a36 0%, #1b2b28 100%)',
            '--gradient-accent': 'linear-gradient(90deg, #10b981 0%, #0f766e 100%)',
            '--gradient-accent-hover': 'linear-gradient(90deg, #34d399 0%, #14b8a6 100%)',
            '--glass-bg': 'rgba(27, 43, 40, 0.75)',
            '--glass-bg-light': 'rgba(16, 185, 129, 0.04)',
            '--glass-bg-hover': 'rgba(16, 185, 129, 0.08)',
            '--glass-border': 'rgba(16, 185, 129, 0.15)',
            '--glass-border-hover': 'rgba(16, 185, 129, 0.25)',
            '--border-color': 'rgba(16, 185, 129, 0.1)',
            '--hover-bg': 'rgba(16, 185, 129, 0.06)',
        }
    },
    dracula: {
        primary: 'bg-[#282a36]',
        secondary: 'bg-[#1e1f29]/90',
        text: 'text-[#f8f8f2]',
        accent: 'bg-[#bd93f9]',
        highlight: 'bg-[#bd93f9]/15 text-[#bd93f9] border border-[#bd93f9]/30',
        opponent: 'bg-[#44475a]/90 backdrop-blur-xl',
        badge: 'bg-[#ff79c6]',
        hover: 'hover:bg-[#44475a]',
        input: 'bg-[#282a36] border border-[#bd93f9]/30',
        bubbleSelf: 'linear-gradient(135deg, #ff79c6 0%, #bd93f9 100%)',
        bubbleOther: 'rgba(68, 71, 90, 0.85)',
        button: 'bg-gradient-to-r from-[#ff79c6] to-[#bd93f9]',
        modalHeader: 'bg-[#1e1f29]',
        sidebar: 'bg-[#1e1f29]/95 backdrop-blur-3xl',
        header: 'bg-[#282a36]/80 backdrop-blur-3xl',
        chat: '#282a36',
        inputBg: 'rgba(68, 71, 90, 0.6)',
        border: 'border-[#44475a]',
        shadow: 'shadow-2xl shadow-black/50',
        hoverShadow: 'hover:shadow-[#bd93f9]/20',
        transition: 'transition-all duration-300 cubic-bezier(0.4, 0, 0.2, 1)',
        cssVars: {
            '--primary-bg': '#282a36',
            '--secondary-bg': '#1e1f29',
            '--text-primary': '#f8f8f2',
            '--text-secondary': '#6272a4',
            '--accent-primary': '#bd93f9',
            '--accent-secondary': '#ff79c6',
            '--gradient-primary': 'linear-gradient(135deg, #ff79c6 0%, #bd93f9 100%)',
            '--gradient-secondary': 'linear-gradient(135deg, #44475a 0%, #1e1f29 100%)',
            '--gradient-accent': 'linear-gradient(90deg, #ff79c6 0%, #bd93f9 100%)',
            '--gradient-accent-hover': 'linear-gradient(90deg, #ff92df 0%, #caa9fa 100%)',
            '--glass-bg': 'rgba(30, 31, 41, 0.75)',
            '--glass-bg-light': 'rgba(189, 147, 249, 0.04)',
            '--glass-bg-hover': 'rgba(189, 147, 249, 0.08)',
            '--glass-border': 'rgba(189, 147, 249, 0.15)',
            '--glass-border-hover': 'rgba(189, 147, 249, 0.25)',
            '--border-color': 'rgba(189, 147, 249, 0.1)',
            '--hover-bg': 'rgba(189, 147, 249, 0.06)',
        }
    }
};